import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ErrorOutlineIcon(props: IconProps) {
    return <Icon {...props} iconKey={"error_outline"}/>
}
